import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useDarkMode } from "../contexts/ThemeContext";
import { useDevMode } from "../contexts/ThemeContext";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import "./../style/NotFound.css";

function NotFound() {
  const navigate = useNavigate();
  const { darkMode } = useDarkMode();
  const { t } = useTranslation();
  const { registerDevAction, clearDevActions } = useDevMode();

  // register dev mode button
  useEffect(() => {
    const devAction1 = {
      label: "Skip to Login",
      onClick: () => navigate("/login"),
    };

    const devAction2 = {
      label: "Placeholder Function",
      onClick: () => {
        navigate("/placeholder");
      },
    };

    registerDevAction(devAction1);
    registerDevAction(devAction2);

    return () => {
      clearDevActions();
    };
  }, [navigate, registerDevAction, clearDevActions]);

  const handleGoBack = () => {
    // check if there's history to go back to
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate("/login");
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: darkMode ? "#1a1a1a" : "#f5f5f5",
        textAlign: "center",
        padding: 3,
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          marginBottom: 2,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: "80px", md: "150px" },
            fontWeight: 700,
            color: "#669d2e",
            fontFamily: "Poppins",
            margin: 0,
          }}
        >
          404
        </Typography>
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          bounce
          style={{
            fontSize: "80px",
            color: "#669d2e",
            opacity: 0.9,
          }}
        />
      </Box>

      <Typography
        variant="h4"
        sx={{
          color: darkMode ? "#ffffff" : "#333333",
          marginBottom: 2,
          fontFamily: "Poppins",
          fontWeight: 600,
        }}
      >
        {t("Page Not Found")}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: darkMode ? "#b0b0b0" : "#666666",
          marginBottom: 4,
          maxWidth: "500px",
          fontFamily: "Poppins",
        }}
      >
        {t("Oops! The page you're looking for doesn't exist.")}
      </Typography>

      {/* buttons */}
      <Box
        sx={{
          display: "flex",
          gap: 2,
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        <Button
          variant="contained"
          onClick={handleGoBack}
          sx={{
            backgroundColor: "#669d2e",
            color: "white",
            padding: "12px 40px",
            fontSize: "16px",
            fontFamily: "Poppins",
            fontWeight: 600,
            borderRadius: "8px",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#558024",
            },
          }}
        >
          {t("Go Back")}
        </Button>
      </Box>
    </Box>
  );
}

export default NotFound;